export default "__VITE_ASSET__3e32d833__"